"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberPart = function (text) { return ({
    areaCode: false,
    decorative: false,
    dialingCode: false,
    e164: true,
    extension: false,
    international: true,
    local: true,
    text: function () { return text.toString(); },
}); };
exports.extensionPart = function (text) { return ({
    areaCode: false,
    decorative: false,
    dialingCode: false,
    e164: true,
    extension: true,
    international: true,
    local: true,
    text: function () { return text.toString(); },
}); };
exports.extensionDecorativePart = function (config) { return ({
    areaCode: false,
    decorative: true,
    dialingCode: false,
    e164: true,
    extension: true,
    international: true,
    local: true,
    text: function (format) { return format === "e164" /* E164 */ ? config.delimiter : config.decoratedDelimiter; },
}); };
exports.countryCodePart = function (text) { return ({
    areaCode: false,
    decorative: false,
    dialingCode: true,
    e164: true,
    extension: false,
    international: true,
    local: false,
    text: function () { return text; },
}); };
exports.areaCodePart = function (text) { return ({
    areaCode: true,
    decorative: false,
    dialingCode: false,
    e164: true,
    extension: false,
    international: true,
    local: true,
    text: function () { return text; },
}); };
exports.decorativePart = function (text) { return ({
    areaCode: false,
    decorative: true,
    dialingCode: false,
    e164: false,
    extension: false,
    international: true,
    local: true,
    text: function () { return text; },
}); };
exports.localDecorativePart = function (text) { return ({
    areaCode: false,
    decorative: true,
    dialingCode: false,
    e164: false,
    extension: false,
    international: false,
    local: true,
    text: function () { return text.toString(); },
}); };
exports.internationalDecorativePart = function (text) { return ({
    areaCode: false,
    decorative: true,
    dialingCode: false,
    e164: false,
    extension: false,
    international: true,
    local: false,
    text: function () { return text; },
}); };
//# sourceMappingURL=number-part.js.map